module.exports = __webpack_public_path__ + "img/3.0b49d96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brochure/academic/3.png
// module id = 588
// module chunks = 5